import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from "@angular/material/snack-bar";

export const APPROVED = 'F';
export const PENDING = 'P';
export const ACTIVE = 'A';
export const HORIZONTAL_POSITION: MatSnackBarHorizontalPosition = 'center';
export const VERTICAL_POSITION: MatSnackBarVerticalPosition = 'top';
